export const textMaxLength = (text, maxLength, dots = false) =>
  String(text).length > maxLength ? (`${ String(text?.substring(0, maxLength))}${dots ? "..." : "" }` || text ) : text;